import React, { Component } from "react";
import { Link } from "react-router-dom";
// components
import Header from "./Header";
import Footer from "./Footer";
import Preloader from "./Preloader";

import "./Categories.css";

import { getPostsByCategory, getCategoryFromSlug } from "./fetch/fetchApi";

class Categories extends Component {
  constructor(props) {
    super(props);

    this.getPostImgs = this.getPostImgs.bind(this);
    this.displayPosts = this.displayPosts.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.removePreloader = this.removePreloader.bind(this);
    this.fetchNewCategories = this.fetchNewCategories.bind(this);

    this.scrollcount = 1;
    this.processing = false;

    this.state = {
      cat: {},
      newPreloader: true,
      currentCategory: "",
      scrollPreloader: false
    };
  }

  componentWillMount() {
    window.addEventListener("scroll", this.handleScroll);

    const catIdReq = getCategoryFromSlug(
      this.props.url.match.params.categoryid
    );
    catIdReq.then(catId => {
      const catReq = getPostsByCategory(catId, 1);
      catReq.then(cat => {
        this.setState({
          currentCategory: catId,
          cat,
          newPreloader: false
        });
      });
    });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    if (!this.processing) {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight * 0.75
      ) {
        this.processing = true;
        this.scrollcount = this.scrollcount + 1;
        this.setState({ scrollPreloader: true });
        this.fetchNewCategories(this.scrollcount);
      }
    }
  }

  fetchNewCategories(count) {
    const catReq = getPostsByCategory(this.state.currentCategory, count);
    catReq.then(cat => {
      if (typeof cat !== "undefined") {
        this.processing = false;
        this.setState({
          cat: this.state.cat.concat(cat)
        });
        this.setState({ scrollPreloader: false });
      } else {
        console.log("remove handler end of posts");
        window.removeEventListener("scroll", this.handleScroll);
        this.setState({ scrollPreloader: false });
      }
    });
  }

  removePreloader() {
    this.setState({ preloader: false });
  }

  getPostImgs() {
    const img = [],
      posts = this.state.cat;

    let firstLoop = true;

    for (let postNumber in posts) {
      let post = posts[postNumber];
      if (post) {
        if (post._embedded["wp:featuredmedia"]) {
          if (firstLoop) {
            img.push([
              post._embedded["wp:featuredmedia"][0].media_details.sizes.large
                .source_url,
              post.slug
            ]);
            firstLoop = false;
          } else {
            img.push([
              post._embedded["wp:featuredmedia"][0].media_details.sizes[
                "medium_large"
              ].source_url,
              post.slug
            ]);
          }
        }
      }
    }

    return img.map((image, index) => {
      if (index > 0) {
        return (
          <div key={index} className="medium-3 small-6 columns">
            <Link to={`/project/${image[1]}`}>
              <img className="App__category-image" src={image[0]} alt="image" />
            </Link>
          </div>
        );
      } else {
        return (
          <div key={index} className="small-12 columns">
            <Link to={`/project/${image[1]}`}>
              <img
                className="App__category-hero-img"
                src={image[0]}
                alt="image"
              />
            </Link>
            <span className="App__category-title">
              #{this.props.url.match.params.categoryid}
            </span>
          </div>
        );
      }
    });
  }

  displayPosts() {
    return (
      <div className="App__intro App__intro--categories">
        <div className="row collapse expanded">{this.getPostImgs()}</div>
      </div>
    );
  }

  render() {
    return (
      <div className="App">
        <Preloader preloader={this.state.newPreloader} />
        <Header type="simple" />
        {this.displayPosts()}
        <Preloader
          preloader={this.state.scrollPreloader}
          type="preloader--smaller"
        />
        <Footer />
      </div>
    );
  }
}

export default Categories;



// WEBPACK FOOTER //
// ./src/components/Categories.js